import { forwardRef, type SVGProps } from 'react';

export interface MirrorHorizontalAxisIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const MirrorHorizontalAxisIcon = forwardRef<SVGSVGElement, MirrorHorizontalAxisIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 20 18">
    <path
      d="M18.75 9.625 1.25 9.625C.905 9.625.625 9.345.625 9 .625 8.655.905 8.375 1.25 8.375L18.75 8.375C19.095 8.375 19.375 8.655 19.375 9 19.375 9.345 19.095 9.625 18.75 9.625ZM5.875 12C5.66 11.839 5.572 11.558 5.657 11.302 5.742 11.047 5.981 10.875 6.25 10.875H13.75C14.095 10.875 14.375 11.155 14.375 11.5V17.125C14.375 17.362 14.241 17.578 14.03 17.684 13.818 17.79 13.565 17.767 13.375 17.625L5.875 12ZM13.125 15.876V12.125H8.124L13.125 15.876ZM5.657 6.698C5.572 6.443 5.66 6.162 5.875 6L13.375.375C13.565.233 13.818.21 14.03.316 14.241.422 14.375.638 14.375.875V6.5C14.375 6.845 14.095 7.125 13.75 7.125L6.25 7.125C5.981 7.125 5.742 6.953 5.657 6.698ZM13.125 5.875V2.124L8.124 5.875H13.125Z"
      fill="currentColor"
    />
  </svg>
));

MirrorHorizontalAxisIcon.displayName = 'MirrorHorizontalAxisIcon';
